// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:16a9471d-e420-4873-8ac4-228d89f313aa",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_o44wFfZ1X",
    "aws_user_pools_web_client_id": "5j8ccp48hoc9b7na3j93hea8h2",
    "oauth": {},
    "aws_mobile_analytics_app_id": "068fc53e222d4b9c98a75748afb2a4e9",
    "aws_mobile_analytics_app_region": "us-east-1",
    "aws_user_files_s3_bucket": "cmpe172proj1e68bdf02ee3842e98758fca9ea871e52-local",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://w73b56zjmzcszlxriqq2ofhb3m.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-l6eztvfqkfbxlczqtg6r7nfm4m",
    "aws_content_delivery_bucket": "cmpe172proj1-20191023213548-hostingbucket-local",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d3rprkps2q5szo.cloudfront.net"
};


export default awsmobile;
